import { get } from 'svelte/store';
import * as PROXY from '../../../common/api.js';
import * as PEGASUS from '@smatch/pegasus-api-docs';
import { USER_STORE, USER_HASH } from './store.js';
import { ORGANIZATION_KEY } from '../../authentication/services/store.js';
const DOMAIN = import.meta.env.VITE_DOMAIN;
import * as SESSION_API from '../../authentication/services/api.js';
export * from './types.js';
// Store Functions
const updateStore = (response, USER_HASH = null) => {
    if ('_' in response) {
        PROXY.updateStore(USER_STORE, USER_HASH, response);
        void SESSION_API.sync({ userKey: response._.key });
    }
    return response;
};
/* eslint-disable arrow-body-style */
// Filter Users
export const filterUsers = async (parameters = {}) => {
    if (DOMAIN !== 'internal') {
        parameters.organizationKeys = [get(ORGANIZATION_KEY) ?? ''];
    }
    return PROXY.handleFilter(PEGASUS.filterUsers, parameters)
        .then(users => PROXY.updateStoreBulk(USER_STORE, users));
};
export const filterMiniUsers = async (parameters = {}) => {
    if (DOMAIN !== 'internal') {
        parameters.organizationKeys = [get(ORGANIZATION_KEY) ?? ''];
    }
    return PROXY.handleFilter(PEGASUS.filterMiniUsers, parameters);
};
// Fetch User
export const fetchUser = async (keys, onError) => {
    return PROXY.handleFetch(PEGASUS.fetchUser, keys)
        .then(({ data, statusCode }) => {
        if (onError?.(statusCode) === true) {
            return {};
        }
        if (statusCode !== 'STATUS_200') {
            PROXY.handleApiError(statusCode);
            return {};
        }
        return PROXY.updateStore(USER_STORE, null, data);
    });
};
// Create User
export const createUser = async (body) => {
    return PROXY.handleCreate(PEGASUS.createUser, body)
        .then(response => updateStore(response, USER_HASH));
};
// Update User
export const updateUser = async (keys, body) => {
    return PROXY.handleUpdate(PEGASUS.updateUser, keys, body)
        .then(response => updateStore(response, USER_HASH));
};
// Delete User
export const deleteUser = async (keys) => {
    return PROXY.handleDelete(PEGASUS.deleteUser, keys)
        .then(response => PROXY.removeFromStore(USER_STORE, USER_HASH, keys.userKey, response));
};
// Update User State
// eslint-disable-next-line max-len
export const updateUserState = async (keys, body) => {
    return PROXY.handleUpdate(PEGASUS.updateUserState, keys, body)
        .then(response => updateStore(response, USER_HASH));
};
// Upload User Image
export const uploadUserImage = async (keys, body) => PROXY.handleUpload(PEGASUS.userCreateImage, keys, body);
// Check whether a user with a provided email already exists
export const doesUserEmailExist = async (email) => {
    const PARAMETERS = { query: email };
    const USERS = await PROXY.handleFilter(PEGASUS.filterUsers, PARAMETERS);
    return USERS.length > 0;
};
/* eslint-enable arrow-body-style */ 
